module.exports = __webpack_public_path__ + "static/assets/7e6696e04524ed9dfe637361eb740c0d.png";